import {
  IsEmail,
  IsEnum,
  IsNotEmpty,
  IsString,
  MaxLength,
} from 'class-validator';
import { CountryCode, UserTitle } from '../enum';

export class RequestAccessCommand {
  @IsNotEmpty()
  @IsString()
  @MaxLength(255)
  login: string;

  @IsNotEmpty()
  @IsEmail()
  @MaxLength(255)
  email: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(255)
  firstName: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(255)
  lastName: string;

  @IsNotEmpty()
  @IsEnum(CountryCode)
  country: CountryCode;

  @IsNotEmpty()
  @IsString()
  @MaxLength(255)
  organisationName: string;

  @IsNotEmpty()
  @IsEnum(UserTitle)
  title: UserTitle;
}
